'use client'
import { Link } from '@/src/navigation'
import { useTranslations } from 'next-intl'
import { useLocale } from 'use-intl'
import Image from 'next/image'

const ClientNotFound = () => {
  const t = useTranslations('')
  const locale = useLocale()

  return (
    <div className='error_page footer_apps_widget'>
       <Image
        className='img-fluid img-thumb contain mt-4'
        src='/assets/images/resource/error.png'
        width="660"
        height="500"
        alt='Error Image'
      />
      <div className='erro_code mt-4'>
        <h1>{t('Page Not Found')}</h1>
      </div>
      <p className='mt-4'>
        {t("We can't find the page you need This estate may have been sold")}
      </p>

      <Link
        lang={locale}
        href={'/'}
        className='btn btn_error btn-thm mt-4'
        style={{ marginBottom: '60px' }}
      >
        {t('Back to home page')}
      </Link>
    </div>
  )
}

export default ClientNotFound
